module.exports = __webpack_public_path__ + "img/steel-fab-logo.3f1666f6.jpg";